export default "__VITE_ASSET__BeD4BhiH__"